export default __webpack_public_path__ + "static/media/Img_ApplyNow_01.47db28d3.jpg";